import { useState } from "react"
import { useSearchParams } from "react-router"

import Layout, { PageTitle } from "~/components/Layout"
import PartialLoadingPage from "~/components/PartialLoadingPage"
import { useUser } from "~/contexts/UserContext"
import { query } from "~/utilities/trpc"

import CreateModal from "./CreateModal"
import EditModal from "./EditModal"
import Memberships from "./Memberships"
import MembersModal from "./MembersModal"
import NoMemberships from "./NoMemberships"

const MembershipPage: React.FC = () => {
	const user = useUser()
	const [searchParams] = useSearchParams()

	const { data: memberships, error, refetch } = query.membership.list.useQuery()

	const [isCreateModalOpen, setCreateModalOpen] = useState(searchParams.get("create") === "true")
	const [editModal, setEditModal] = useState<{ isOpen: boolean; membershipId: number | null }>({
		isOpen: false,
		membershipId: null,
	})
	const [membersModal, setMembersModal] = useState<{ isOpen: boolean; membershipId: number | null }>({
		isOpen: false,
		membershipId: null,
	})

	async function handleSubmitted() {
		if (memberships?.length === 0) await user.reload()
		await refetch()
	}

	return (
		<Layout>
			<CreateModal
				isOpen={isCreateModalOpen}
				onClose={() => setCreateModalOpen(false)}
				onSubmitted={handleSubmitted}
			/>
			<EditModal
				membershipId={editModal.membershipId}
				isOpen={editModal.isOpen}
				onClose={() => setEditModal(current => ({ ...current, isOpen: false }))}
				onSubmitted={handleSubmitted}
			/>
			<MembersModal
				membershipId={membersModal.membershipId}
				isOpen={membersModal.isOpen}
				onClose={() => setMembersModal(current => ({ ...current, isOpen: false }))}
			/>
			<PageTitle>Membership</PageTitle>
			{error ? (
				<p>Failed to fetch memberships.</p>
			) : memberships === undefined ? (
				<PartialLoadingPage />
			) : memberships.length > 0 ? (
				<Memberships
					memberships={memberships}
					onCreateTier={() => setCreateModalOpen(true)}
					onEditMembership={membershipId => setEditModal({ isOpen: true, membershipId })}
					onListMembers={membershipId => setMembersModal({ isOpen: true, membershipId })}
				/>
			) : (
				<NoMemberships onCreateTier={() => setCreateModalOpen(true)} />
			)}
		</Layout>
	)
}

export default MembershipPage
